import { hookstate } from "@hookstate/core";

const metaMaskStore = {
    isConnected: false,
    address: null,
    walletIcon: null,
    walletName: null,
};

const isProfileClicked = {
    isClicked: false,
};

export const metaMaskState = hookstate(metaMaskStore);
export const isProfileClickedState = hookstate(isProfileClicked);
